import React from "react";

import { TravelData } from "../shared/type";

interface TravelDataRendererProps {
  data: TravelData;
}

const TravelDataRenderer: React.FC<TravelDataRendererProps> = ({ data }) => {
  return (
    <div className="space-y-4 mt-3">
      {/* Itinerary */}
      {data.itinerary && data.itinerary.length > 0 && (
        <div>
          <h3 className="font-bold text-base mb-2">
            Here's your personalized itinerary:
          </h3>
          <div className="space-y-3">
            {data.itinerary.map((day, dayIndex) => (
              <div
                key={dayIndex}
                className="border-l-2 border-[#406388] pl-3 animate-fadeIn"
                style={{
                  animation: `fadeIn 0.5s ease-in ${dayIndex * 0.1}s both`,
                }}
              >
                <div className="font-semibold text-sm mb-1">
                  {day.day} - {day.date}
                </div>
                <div className="space-y-1 ml-2">
                  {day.schedule.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className="text-sm animate-fadeIn"
                      style={{
                        animation: `fadeIn 0.4s ease-in ${
                          dayIndex * 0.1 + itemIndex * 0.05
                        }s both`,
                      }}
                    >
                      <span className="font-medium">{item.time}:</span>{" "}
                      {item.activity}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Top Attractions */}
      {data.topAttractions && data.topAttractions.length > 0 && (
        <div>
          <h3 className="font-bold text-base mb-2">Top Attractions:</h3>
          <ul className="space-y-2">
            {data.topAttractions.map((attraction, index) => (
              <li
                key={index}
                className="text-sm animate-fadeIn"
                style={{
                  animation: `fadeIn 0.4s ease-in ${index * 0.1}s both`,
                }}
              >
                <span className="font-medium">• {attraction.name}</span> -{" "}
                {attraction.description}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Travel Tips */}
      {data.travelTips && data.travelTips.length > 0 && (
        <div>
          <h3 className="font-bold text-base mb-2">Travel Tips:</h3>
          <ul className="space-y-1">
            {data.travelTips.map((tip, index) => (
              <li
                key={index}
                className="text-sm animate-fadeIn"
                style={{
                  animation: `fadeIn 0.4s ease-in ${index * 0.08}s both`,
                }}
              >
                • {tip}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TravelDataRenderer;
